import type { ConsentRegion } from "./regions";
import type { CategoryKey } from "./version";

export interface ConsentLogPayload {
  eventType: "first_consent" | "update" | "withdraw" | "do_not_sell";
  categories: Record<CategoryKey, boolean>;
  region?: ConsentRegion | null;
  consentVersion: string;
  gpcSignal?: boolean;
}

export async function logConsent(payload: ConsentLogPayload): Promise<void> {
  try {
    await fetch("/api/consent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch {
    // Silent fail — banner UX must never break on logging error
  }
}
